import { useLocation, useHistory } from 'react-router-dom';

export const useSearchParams = () => {
  const location = useLocation();
  const history = useHistory();

  const getSearchParams = () => {
    return new URLSearchParams(location.search);
  };

  const getSearchParam = (key: string) => {
    const params = new URLSearchParams(location.search)
    return params.get(key)
  }

  const setSearchParams = (params: Record<string, string>) => {
    const searchParams = new URLSearchParams(location.search);

    Object.keys(params).forEach((key) => {
      searchParams.set(key, params[key]);
    });

    history.push({ search: searchParams.toString() });
  };

  const removeSearchParam = (key: string) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete(key);
    history.push({ search: searchParams.toString() });
  };

  return {
    getSearchParams,
    getSearchParam,
    setSearchParams,
    removeSearchParam,
  };
}